<template>
	<div class="card-item-wrapper">
		<div class="card-item-main">
			<slot></slot>
		</div>
		<el-button type="primary" plain class="card-item-btn" @click="handleMore">{{
			$t('enterprise.view')
		}}</el-button>
	</div>
</template>

<script setup>
const emits = defineEmits(['more']);
const handleMore = () => {
	emits('more');
};
</script>

<style lang="less" scoped>
.card-item-wrapper {
	padding: 12px 16px;
	min-height: 60px;
	border-radius: 2px;
	border: 1px solid #f2f3f5;
	background: rgba(255, 255, 255, 0.4);
	cursor: pointer;
	display: flex;
	align-items: center;
	transition: all ease 0.3s;

	&:hover {
		/* 复杂背景/右下 */
		box-shadow: 1px 4px 16px 0px rgba(0, 0, 0, 0.08);
		backdrop-filter: blur(7px);

		.card-item-btn {
			margin-left: 10px;
			flex: none;
			display: block;
		}
	}

	.card-item-main {
		flex: 1;
		width: 0;
	}
	.card-item-btn {
		display: none;
	}
}
</style>
